import { Reducer } from "redux";

import {
  IDashboardActionTypes,
  IDashboardState,
  IPoliticalRegime,
  IGroupList,
  ISubGroupList,
  IPoliticalGroupId,
  IPoliticalGroupSimple,
  IFilters,
  ITotalPoliticalGroup,
  IPeriodSimple,
  monthsOfYear,
  IPoliticalGroup,
} from "./Types";

let initialState: IDashboardState = {
  politicalRegimeList: [],
  politicalGroupList: [],
  dashboardResults: null,
  filters: {
    media_ids: [],
    program_type_ids: [],
    media_str: [],
    program_type_str: [],
    program_editors_ids: [],
    program_editors_str: [],
    time_slot_start: "",
    time_slot_end: "",
    date_type: "calendar",
    date_start: new Date(),
    date_end: new Date(),
    display_format: "duration",
  },
  detailsFilters: {
    media_ids: [],
    program_type_ids: [],
    program_editor_ids: [],
    time_slot_start: "",
    time_slot_end: "",
    date_start: new Date(),
    date_end: new Date(),
    political_regime_ids: [],
    political_group_ids: [],
    study_type_id: 24,
    program_name: undefined, // Ajouter le nouveau champ
  },
  selectedDate: "",
  selectedName: "",
  columns: null,
  data: [],
  dataHms: [],
  dataPercent: [],
  months: [],
  isLoading: false,
  dashboardDetail: null,
  isLoadingDetail: false,
  initialPoliticalGroupID: [],
  initialPoliticalGroupStr: [],
  dateCloture: null,
  loadingDateCloture: false,
  emissions: [],
  isEmissionAutocompleteLoading: false,
};

const reducer: Reducer<IDashboardState> = (state = initialState, action) => {
  switch (action.type) {
    case IDashboardActionTypes.GET_DATE_CLOTURE: {
      return {
        ...state,
        loadingDateCloture: true,
      };
    }
    case IDashboardActionTypes.GET_DATE_CLOTURE_SUCCESS: {
      let day = action.payload;
      return {
        ...state,
        dateCloture: day,
        loadingDateCloture: false,
      };
    }
    case IDashboardActionTypes.GET_POLITICAL_GROUP_SUCCESS: {
      let groups = action.payload;
      let groupsID: number[] = groups.map((x: IPoliticalGroup) => {
        return x.political_group_id;
      });
      let groupsStr: string[] = groups.map((x: IPoliticalGroup) => {
        return x.political_group_name;
      });
      return {
        ...state,
        politicalGroupList: action.payload,
        initialPoliticalGroupID: groupsID,
        initialPoliticalGroupStr: groupsStr,
      };
    }
    case IDashboardActionTypes.GET_DASHBOARD: {
      let months: string[] = [];
      let newFilters = action.payload as IFilters;
      let dataCopy: any = [];
      if (newFilters !== undefined) {
        let startMonth =
          new Date(newFilters.date_start).getMonth() + 1 === 12
            ? 0
            : new Date(newFilters.date_start).getMonth();
        let endMonth =
          new Date(newFilters.date_end).getFullYear() >
          new Date(newFilters.date_start).getFullYear()
            ? 11
            : new Date(newFilters.date_end).getMonth();
        let ilimit: number = 0;
        switch (newFilters.date_type) {
          case "quarter":
            ilimit = 3;
            break;
          case "semester":
            ilimit = 6;
            break;
          case "annual":
            ilimit = 12;
            break;
          default:
            break;
        }
        let i = 0;
        while (startMonth + i < endMonth + 1 && i < ilimit) {
          months.push(monthsOfYear[startMonth + i]);
          i++;
        }
        if (newFilters.date_type === "annual") {
          for (let i = 0; i < months.length; i++) {
            dataCopy.push({
              Libelle: months[i],
            });
            if (
              (i === 2 && months.length > 2) ||
              (i === months.length - 1 && months.length < 2)
            ) {
              dataCopy.push({
                Libelle: "Total du premier trimestre en hh:mm:ss",
              });
              dataCopy.push({
                Libelle: "Total du premier trimestre en %",
              });
              dataCopy.push({
                Libelle: "Total du premier trimestre en % (base 100)",
              });
            }
            if (
              (i === 5 && months.length > 5) ||
              (i === months.length - 1 &&
                months.length < 5 &&
                months.length > 3)
            ) {
              dataCopy.push({
                Libelle: "Total du deuxième trimestre en hh:mm:ss",
              });
              dataCopy.push({
                Libelle: "Total du deuxième trimestre en %",
              });
              dataCopy.push({
                Libelle: "Total du deuxième trimestre en % (base 100)",
              });
            }
            if (
              (i === 8 && months.length > 8) ||
              (i === months.length - 1 &&
                months.length < 8 &&
                months.length > 6)
            ) {
              dataCopy.push({
                Libelle: "Total du troisième trimestre en hh:mm:ss",
              });
              dataCopy.push({
                Libelle: "Total du troisième trimestre en %",
              });
              dataCopy.push({
                Libelle: "Total du troisième trimestre en % (base 100)",
              });
            }
            if (
              (i === 11 && months.length > 11) ||
              (i === months.length - 1 &&
                months.length < 11 &&
                months.length > 9)
            ) {
              dataCopy.push({
                Libelle: "Total du quatrième trimestre en hh:mm:ss",
              });
              dataCopy.push({
                Libelle: "Total du quatrième trimestre en %",
              });
              dataCopy.push({
                Libelle: "Total du quatrième trimestre en % (base 100)",
              });
            }
          }
          dataCopy.push({
            Libelle: `Total ${new Date(newFilters.date_start).getFullYear()} en hh:mm:ss`,
          });
          dataCopy.push({
            Libelle: `Total ${new Date(
              newFilters.date_start
            ).getFullYear()} en %`,
          });
          dataCopy.push({
            Libelle: `Total ${new Date(
              newFilters.date_start
            ).getFullYear()} en % (base 100)`,
          });
        } else if (newFilters.date_type === "semester") {
          if (months[0] === "Janvier") {
            for (let i = 0; i < months.length; i++) {
              dataCopy.push({
                Libelle: months[i],
              });
              if (
                (i === 2 && months.length > 2) ||
                (i === months.length - 1 && months.length < 2)
              ) {
                dataCopy.push({
                  Libelle: "Total du premier trimestre en hh:mm:ss",
                });
                dataCopy.push({
                  Libelle: "Total du premier trimestre en %",
                });
                dataCopy.push({
                  Libelle: "Total du premier trimestre en % (base 100)",
                });
              }
              if (
                (i === 5 && months.length > 5) ||
                (i === months.length - 1 &&
                  months.length < 5 &&
                  months.length > 3)
              ) {
                dataCopy.push({
                  Libelle: "Total du deuxième trimestre en hh:mm:ss",
                });
                dataCopy.push({
                  Libelle: "Total du deuxième trimestre en %",
                });
                dataCopy.push({
                  Libelle: "Total du deuxième trimestre en % (base 100)",
                });
              }
            }
          } else {
            for (let i = 0; i < months.length; i++) {
              dataCopy.push({
                Libelle: months[i],
              });
              if (
                (i === 2 && months.length > 2) ||
                (i === months.length - 1 && months.length < 2)
              ) {
                dataCopy.push({
                  Libelle: "Total du troisième trimestre en hh:mm:ss",
                });
                dataCopy.push({
                  Libelle: "Total du troisième trimestre en %",
                });
                dataCopy.push({
                  Libelle: "Total du troisième trimestre en % (base 100)",
                });
              }
              if (
                (i === 5 && months.length > 5) ||
                (i === months.length - 1 &&
                  months.length < 5 &&
                  months.length > 3)
              ) {
                dataCopy.push({
                  Libelle: "Total du quatrième trimestre en hh:mm:ss",
                });
                dataCopy.push({
                  Libelle: "Total du quatrième trimestre en %",
                });
                dataCopy.push({
                  Libelle: "Total du quatrième trimestre en % (base 100)",
                });
              }
            }
          }
          dataCopy.push({
            Libelle: "Total du semestre en hh:mm:ss",
          });
          dataCopy.push({
            Libelle: "Total du semestre en %",
          });
          dataCopy.push({
            Libelle: "Total du semestre en % (base 100)",
          });
        } else if (newFilters.date_type === "quarter") {
          for (let i = 0; i < months.length; i++) {
            dataCopy.push({
              Libelle: months[i],
            });
          }
          dataCopy.push({
            Libelle: "Total du trimestre en hh:mm:ss",
          });
          dataCopy.push({
            Libelle: "Total du trimestre en %",
          });
          dataCopy.push({
            Libelle: "Total du trimestre en % (base 100)",
          });
        }
      }

      return {
        ...state,
        filters: action.payload,
        months: months,
        data: dataCopy,
        dataHms: dataCopy,
        dataPercent: dataCopy,
        isLoading: true,
      };
    }
    case IDashboardActionTypes.GET_DASHBOARD_SUCCESS: {
        let results = action.payload;
        let regimes = results.political_regime_ids;
        let orderedRegimes: any = {};
        let orderedRegimeArray: any = [];
        let orderedArray: number[] = [
          183, 181, 182, 121, 64, 65, 66, 67, 68, 69, 70, 71, 142,
        ];

        orderedArray.map((regimeId) => {
          Object.keys(regimes).map((regime_id) => {
            let regime = regimes[regime_id];
            let groups = regime.political_group_ids;
            let orderedGroupsArray: any = [];
            let randomGroups: any = [];
            let orderedGroupIds: number[] = regime.political_group_order;
            orderedGroupIds.map((groupId: number) => {
              Object.keys(groups).map((group_id) => {
                let group = groups[group_id];
                if (orderedGroupIds.indexOf(group.political_group_id) > -1) {
                  if (group.political_group_id === groupId) {
                    orderedGroupsArray.push(group);
                  }
                } else if (
                  !randomGroups.some(
                    (x: any) =>
                      x.political_group_id === group.political_group_id
                  )
                ) {
                  randomGroups.push(group);
                }
                return orderedGroupsArray.concat(randomGroups);
              });
              return orderedGroupsArray.concat(randomGroups);
            });
            regime.political_group_ids =
              orderedGroupsArray.concat(randomGroups);
            if (regime.political_regime_id === regimeId) {
              orderedRegimes[regime_id] = regime;
              orderedRegimeArray.push(orderedRegimes[regime_id]);
            }
            return orderedRegimeArray;
          });
          return orderedRegimeArray;
        });

        results = {
          ...results,
          political_regime_ids: orderedRegimeArray,
        };
        return {
          ...state,
          dashboardResults: results,
          politicalRegimeList: orderedRegimeArray,
          isLoading: false,
        };
    }
    case IDashboardActionTypes.GET_DASHBOARD_ERROR: {
      return {
        ...state,
        isLoading: false,
        dataHms: [],
      };
    }
    case IDashboardActionTypes.BUILD_DATA_HMS: {
      let results = state.dashboardResults;
      let dataCopy: any = [...state.dataHms];
      let jsonData: any = {};
      if (results !== null) {
        let politicalRegimeList: IPoliticalRegime[] =
          results.political_regime_ids as IPoliticalRegime[];
        let totals = results.totals;
        Object.keys(totals).map((key: string) => {
          if (key === "total_by_month") {
            let total_by_month = totals[key];
            Object.keys(total_by_month).map((key: string) => {
              let monthNum: number = parseInt(key);
              let monthTotal = total_by_month[key];
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === monthsOfYear[monthNum - 1]
              )[0];
              let index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === monthsOfYear[monthNum - 1]
              );
              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: monthTotal.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              return dataCopy;
            });
          }
          if (key === "total_by_quarter") {
            let quarters = totals.total_by_quarter;
            Object.keys(quarters).map((key) => {
              let quarter: IPeriodSimple = quarters[key];
              jsonData = dataCopy.filter(
                (x: any) =>
                  x["Libelle"] === `${quarter.libelle_row} en hh:mm:ss`
              )[0];
              let index = dataCopy.findIndex(
                (x: any) =>
                  x["Libelle"] === `${quarter.libelle_row} en hh:mm:ss`
              );
              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  "Libelle": `${quarter.libelle_row} en hh:mm:ss`,
                  Total: quarter.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${quarter.libelle_row} en %`
              )[0];
              index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${quarter.libelle_row} en %`
              );
              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: quarter.percent,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) =>
                  x["Libelle"] === `${quarter.libelle_row} en % (base 100)`
              )[0];
              index = dataCopy.findIndex(
                (x: any) =>
                  x["Libelle"] === `${quarter.libelle_row} en % (base 100)`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: quarter.percent,
                };
                dataCopy[index] = jsonData;
              }
              return dataCopy;
            });
          }
          if (key === "total_by_year") {
            let years = totals.total_by_year;
            Object.keys(years).map((key) => {
              let year: IPeriodSimple = years[key];
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
              )[0];
              let index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  "Libelle": `${year.libelle_row} en hh:mm:ss`,
                  Total: year.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${year.libelle_row} en %`
              )[0];
              index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${year.libelle_row} en %`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: year.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) =>
                  x["Libelle"] === `${year.libelle_row} en % (base 100)`
              )[0];
              index = dataCopy.findIndex(
                (x: any) =>
                  x["Libelle"] === `${year.libelle_row} en % (base 100)`
              );
              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: year.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              return dataCopy;
            });
          }
          if (key === "total_by_semester") {
            let semesters = totals.total_by_semester;
            Object.keys(semesters).map((key) => {
              let semester: IPeriodSimple = semesters[key];
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
              )[0];
              let index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  "Libelle": `${semester.libelle_row} en hh:mm:ss`,
                  Total: semester.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${semester.libelle_row} en %`
              )[0];
              index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${semester.libelle_row} en %`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: semester.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) =>
                  x["Libelle"] === `${semester.libelle_row} en % (base 100)`
              )[0];
              index = dataCopy.findIndex(
                (x: any) =>
                  x["Libelle"] === `${semester.libelle_row} en % (base 100)`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: semester.percent,
                };
                dataCopy[index] = jsonData;
              }
              return dataCopy;
            });
          }
          return dataCopy;
        });
        politicalRegimeList !== undefined &&
          politicalRegimeList.length > 0 &&
          politicalRegimeList.map((regime: IPoliticalRegime) => {
            let politicalRegime: IPoliticalRegime = regime;
            let politicalRegimeSubGroup: IPoliticalGroupId =
              politicalRegime.political_group_ids;

            Object.keys(politicalRegime.cumuls).length > 0 &&
              Object.keys(politicalRegime.cumuls).map((key) => {
                if (key === "quarter") {
                  Object.keys(politicalRegime.cumuls.quarter).map((key) => {
                    let quarter = politicalRegime.cumuls.quarter[parseInt(key)];
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] === `${quarter.libelle_row} en hh:mm:ss`
                    )[0];
                    let index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] === `${quarter.libelle_row} en hh:mm:ss`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          quarter.display_hms,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === `${quarter.libelle_row} en %`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) => x["Libelle"] === `${quarter.libelle_row} en %`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          quarter.percent,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] ===
                        `${quarter.libelle_row} en % (base 100)`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] ===
                        `${quarter.libelle_row} en % (base 100)`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          results &&
                            results.totals &&
                            results.totals.total_by_political_regime &&
                            results.totals.total_by_political_regime[
                              regime.political_regime_id
                            ]
                          ? results.totals.total_by_political_regime[
                              regime.political_regime_id
                            ].percent_base100
                          : "--",
                      };
                      dataCopy[index] = jsonData;
                    }
                    return dataCopy;
                  });
                }
                if (key === "month") {
                  Object.keys(politicalRegime.cumuls.month).map(
                    (key: string, keyIndex: number) => {
                      let monthNum = parseInt(key);
                      let monthCumul = politicalRegime.cumuls.month[monthNum];
                      jsonData = dataCopy.filter(
                        (x: any) => x["Libelle"] === monthsOfYear[monthNum - 1]
                      )[0];
                      let index = dataCopy.findIndex(
                        (x: any) => x["Libelle"] === monthsOfYear[monthNum - 1]
                      );

                      if (jsonData !== undefined && index > -1 && monthCumul !== undefined) {
                        jsonData = {
                          ...jsonData,
                          [`Cumuls ${politicalRegime.political_regime_name}`]:
                            monthCumul.display_hms,
                        };
                        dataCopy[index] = jsonData;
                      }
                      return dataCopy;
                    }
                  );
                }
                if (key === "semester") {
                  Object.keys(politicalRegime.cumuls.semester).map((key) => {
                    let semester =
                      politicalRegime.cumuls.semester[parseInt(key)];
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
                    )[0];
                    let index = dataCopy.findIndex(
                      (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          semester.display_hms,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] === `${semester.libelle_row} en %`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] === `${semester.libelle_row} en %`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          semester.percent,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] ===
                        `${semester.libelle_row} en % (base 100)`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] ===
                        `${semester.libelle_row} en % (base 100)`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          results &&
                            results.totals &&
                            results.totals.total_by_political_regime &&
                            results.totals.total_by_political_regime[
                              regime.political_regime_id
                            ]
                          ? results.totals.total_by_political_regime[
                              regime.political_regime_id
                            ].percent_base100
                          : "--",
                      };
                      dataCopy[index] = jsonData;
                    }
                    return dataCopy;
                  });
                }
                if (key === "year") {
                  Object.keys(politicalRegime.cumuls.year).map((key) => {
                    let year = politicalRegime.cumuls.year[parseInt(key)];
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
                    )[0];
                    let index = dataCopy.findIndex(
                      (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
                    );
                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          year.display_hms,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === `${year.libelle_row} en %`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) => x["Libelle"] === `${year.libelle_row} en %`
                    );
                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          year.percent,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] === `${year.libelle_row} en % (base 100)`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] === `${year.libelle_row} en % (base 100)`
                    );
                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          results &&
                            results.totals &&
                            results.totals.total_by_political_regime &&
                            results.totals.total_by_political_regime[
                              regime.political_regime_id
                            ]
                          ? results.totals.total_by_political_regime[
                              regime.political_regime_id
                            ].percent_base100
                          : "--",
                      };
                      dataCopy[index] = jsonData;
                    }
                    return dataCopy;
                  });
                }
                return dataCopy;
              });
            Object.keys(politicalRegimeSubGroup).length > 0 &&
              Object.keys(politicalRegimeSubGroup).map((key: string) => {
                let idGroup = parseInt(key);
                let politicalRegimeGroup: IPoliticalGroupSimple =
                  politicalRegimeSubGroup[idGroup];
                Object.keys(totals).map((key: string) => {
                  if (
                    key === "total_by_political_group" &&
                    state.filters?.date_type === "quarter"
                  ) {
                    let totalGroups = totals["total_by_political_group"];
                    Object.keys(totalGroups).length > 0 &&
                      Object.keys(totalGroups).map((key) => {
                        let idTotalGroup = parseInt(key);
                        let totalGroup: ITotalPoliticalGroup =
                          totalGroups[idTotalGroup];
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en hh:mm:ss"
                              : "Total du premier trimestre")
                        )[0];
                        let index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en hh:mm:ss"
                              : "Total du premier trimestre")
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              totalGroup.display_hms,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en %"
                              : "Total du premier trimestre en %")
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en %"
                              : "Total du premier trimestre en %")
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en % (base 100)"
                              : "Total du premier trimestre en % (base 100)")
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en % (base 100)"
                              : "Total du premier trimestre en % (base 100)")
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent_base100,
                          };
                          dataCopy[index] = jsonData;
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du deuxième trimestre"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du deuxième trimestre"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              totalGroup.display_hms,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du deuxième trimestre en %"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du deuxième trimestre en %"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du deuxième trimestre en % (base 100)"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du deuxième trimestre en % (base 100)"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent_base100,
                          };
                          dataCopy[index] = jsonData;
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du troisième trimestre"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du troisième trimestre"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              totalGroup.display_hms,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du troisième trimestre en %"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du troisième trimestre en %"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du troisième trimestre en % (base 100)"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du troisième trimestre en % (base 100)"
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent_base100,
                          };
                          dataCopy[index] = jsonData;
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du quatrième trimestre"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du quatrième trimestre"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              totalGroup.display_hms,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du quatrième trimestre en %"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du quatrième trimestre en %"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du quatrième trimestre en % (base 100)"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du quatrième trimestre en % (base 100)"
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent_base100,
                          };
                          dataCopy[index] = jsonData;
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) => x["Libelle"] === "Total du semestre"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) => x["Libelle"] === "Total du semestre"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy = [...dataCopy, jsonData];
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en %"
                              : "Total du premier trimestre en %")
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en %"
                              : "Total du premier trimestre en %")
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        return dataCopy;
                      });
                  }
                  return dataCopy;
                });
                Object.keys(politicalRegimeGroup.cumuls).map(
                  (key: string, index: number) => {
                    if (key === "month") {
                      Object.keys(politicalRegimeGroup.cumuls.month).map(
                        (key: string, index: number) => {
                          let monthNum = parseInt(key);
                          let monthCumul =
                            politicalRegimeGroup.cumuls.month[monthNum];
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] === monthsOfYear[monthNum - 1]
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] === monthsOfYear[monthNum - 1]
                          );

                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                monthCumul.display_hms,
                            };
                            dataCopy[index] = jsonData;
                          }
                          return dataCopy;
                        }
                      );
                    }
                    if (key === "quarter") {
                      Object.keys(politicalRegimeGroup.cumuls.quarter).map(
                        (key) => {
                          let quarter: IPeriodSimple =
                            politicalRegimeGroup.cumuls.quarter[parseInt(key)];
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] ===
                              `${quarter.libelle_row} en hh:mm:ss`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] ===
                              `${quarter.libelle_row} en hh:mm:ss`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                quarter.display_hms,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] === `${quarter.libelle_row} en %`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] === `${quarter.libelle_row} en %`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : quarter.percent,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] ===
                              `${quarter.libelle_row} en % (base 100)`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] ===
                              `${quarter.libelle_row} en % (base 100)`
                          );

                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : results &&
                                    results.totals &&
                                    results.totals.total_by_political_group &&
                                    results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ]
                                  ? results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ].percent_base100
                                  : "--",
                            };
                            dataCopy[index] = jsonData;
                          }
                          return dataCopy;
                        }
                      );
                    }
                    if (key === "semester") {
                      Object.keys(politicalRegimeGroup.cumuls.semester).map(
                        (key) => {
                          let semester: IPeriodSimple =
                            politicalRegimeGroup.cumuls.semester[parseInt(key)];
                          jsonData = dataCopy.filter(
                            (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                semester.display_hms,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] === `${semester.libelle_row} en %`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] === `${semester.libelle_row} en %`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : semester.percent,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] ===
                              `${semester.libelle_row} en % (base 100)`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] ===
                              `${semester.libelle_row} en % (base 100)`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : results &&
                                    results.totals &&
                                    results.totals.total_by_political_group &&
                                    results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ]
                                  ? results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ].percent_base100
                                  : "--",
                            };
                            dataCopy[index] = jsonData;
                          }
                          return dataCopy;
                        }
                      );
                    }
                    if (key === "year") {
                      Object.keys(politicalRegimeGroup.cumuls.year).map(
                        (key) => {
                          let year: IPeriodSimple =
                            politicalRegimeGroup.cumuls.year[parseInt(key)];
                          jsonData = dataCopy.filter(
                            (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                year.display_hms,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] === `${year.libelle_row} en %`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] === `${year.libelle_row} en %`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : year.percent,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] ===
                              `${year.libelle_row} en % (base 100)`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] ===
                              `${year.libelle_row} en % (base 100)`
                          );

                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : results &&
                                    results.totals &&
                                    results.totals.total_by_political_group &&
                                    results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ]
                                  ? results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ].percent_base100
                                  : "--",
                            };
                            dataCopy[index] = jsonData;
                          }
                          return dataCopy;
                        }
                      );
                    }
                    return dataCopy;
                  }
                );

                dataCopy.map((x: any) => {
                  if (
                    x[politicalRegimeGroup.political_group_name] === undefined
                  ) {
                    x[politicalRegimeGroup.political_group_name] = "--";
                  }
                  return x;
                });
                return dataCopy;
              });
            return dataCopy;
          });
      }
      return {
        ...state,
        dataHms: dataCopy,
        data: dataCopy,
      };
    }
    case IDashboardActionTypes.BUILD_DATA_PERCENT: {
      let results = state.dashboardResults;
      let dataCopy: any = [...state.dataPercent];
      let jsonData: any = {};
      if (results !== null) {
        let politicalRegimeList: IPoliticalRegime[] =
          results.political_regime_ids as IPoliticalRegime[];
        let totals = results.totals;
        Object.keys(totals).map((key: string) => {
          if (key === "total_by_month") {
            let total_by_month = totals[key];
            Object.keys(total_by_month).map((key: string) => {
              let monthNum: number = parseInt(key);
              let monthTotal = total_by_month[key];
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === monthsOfYear[monthNum - 1]
              )[0];
              let index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === monthsOfYear[monthNum - 1]
              );
              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: monthTotal.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              return dataCopy;
            });
          }
          if (key === "total_by_quarter") {
            let quarters = totals.total_by_quarter;
            Object.keys(quarters).map((key) => {
              let quarter: IPeriodSimple = quarters[key];
              jsonData = dataCopy.filter(
                (x: any) =>
                  x["Libelle"] === `${quarter.libelle_row} en hh:mm:ss`
              )[0];
              let index = dataCopy.findIndex(
                (x: any) =>
                  x["Libelle"] === `${quarter.libelle_row} en hh:mm:ss`
              );
              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: quarter.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${quarter.libelle_row} en %`
              )[0];
              index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${quarter.libelle_row} en %`
              );
              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: quarter.percent,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) =>
                  x["Libelle"] === `${quarter.libelle_row} en % (base 100)`
              )[0];
              index = dataCopy.findIndex(
                (x: any) =>
                  x["Libelle"] === `${quarter.libelle_row} en % (base 100)`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: quarter.percent,
                };
                dataCopy[index] = jsonData;
              }
              return dataCopy;
            });
          }
          if (key === "total_by_year") {
            let years = totals.total_by_year;
            Object.keys(years).map((key) => {
              let year: IPeriodSimple = years[key];
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
              )[0];
              let index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: year.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${year.libelle_row} en %`
              )[0];
              index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${year.libelle_row} en %`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: year.percent,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) =>
                  x["Libelle"] === `${year.libelle_row} en % (base 100)`
              )[0];
              index = dataCopy.findIndex(
                (x: any) =>
                  x["Libelle"] === `${year.libelle_row} en % (base 100)`
              );
              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: year.percent,
                };
                dataCopy[index] = jsonData;
              }
              return dataCopy;
            });
          }
          if (key === "total_by_semester") {
            let semesters = totals.total_by_semester;
            Object.keys(semesters).map((key) => {
              let semester: IPeriodSimple = semesters[key];
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
              )[0];
              let index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: semester.display_hms,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === `${semester.libelle_row} en %`
              )[0];
              index = dataCopy.findIndex(
                (x: any) => x["Libelle"] === `${semester.libelle_row} en %`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: semester.percent,
                };
                dataCopy[index] = jsonData;
              }
              jsonData = dataCopy.filter(
                (x: any) =>
                  x["Libelle"] === `${semester.libelle_row} en % (base 100)`
              )[0];
              index = dataCopy.findIndex(
                (x: any) =>
                  x["Libelle"] === `${semester.libelle_row} en % (base 100)`
              );

              if (jsonData !== undefined) {
                jsonData = {
                  ...jsonData,
                  Total: semester.percent,
                };
                dataCopy[index] = jsonData;
              }
              return dataCopy;
            });
          }
          return dataCopy;
        });
        politicalRegimeList !== undefined &&
          politicalRegimeList.length > 0 &&
          politicalRegimeList.map((regime: IPoliticalRegime) => {
            let politicalRegime: IPoliticalRegime = regime;
            let politicalRegimeSubGroup: IPoliticalGroupId =
              politicalRegime.political_group_ids;

            Object.keys(politicalRegime.cumuls).length > 0 &&
              Object.keys(politicalRegime.cumuls).map((key) => {
                if (key === "quarter") {
                  Object.keys(politicalRegime.cumuls.quarter).map((key) => {
                    let quarter = politicalRegime.cumuls.quarter[parseInt(key)];
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] === `${quarter.libelle_row} en hh:mm:ss`
                    )[0];
                    let index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] === `${quarter.libelle_row} en hh:mm:ss`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          regime.political_regime_name === "PRES REP HORS DEBAT"
                            ? "--"
                            : quarter.display_hms,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === `${quarter.libelle_row} en %`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) => x["Libelle"] === `${quarter.libelle_row} en %`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          regime.political_regime_name === "PRES REP HORS DEBAT"
                            ? "--"
                            : quarter.percent,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] ===
                        `${quarter.libelle_row} en % (base 100)`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] ===
                        `${quarter.libelle_row} en % (base 100)`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          regime.political_regime_name === "PRES REP HORS DEBAT"
                            ? "--"
                            : results &&
                                results.totals &&
                                results.totals.total_by_political_regime &&
                                results.totals.total_by_political_regime[
                                  regime.political_regime_id
                                ]
                              ? results.totals.total_by_political_regime[
                                  regime.political_regime_id
                                ].percent_base100
                              : "--",
                      };
                      dataCopy[index] = jsonData;
                    }
                    return dataCopy;
                  });
                }
                if (key === "month") {
                  Object.keys(politicalRegime.cumuls.month).map(
                    (key: string, index: number) => {
                      let monthNum = parseInt(key);
                      let monthCumul = politicalRegime.cumuls.month[monthNum];
                      jsonData = dataCopy.filter(
                        (x: any) => x["Libelle"] === monthsOfYear[monthNum - 1]
                      )[0];
                      index = dataCopy.findIndex(
                        (x: any) => x["Libelle"] === monthsOfYear[monthNum - 1]
                      );

                      if (jsonData !== undefined) {
                        jsonData = {
                          ...jsonData,
                          [`Cumuls ${politicalRegime.political_regime_name}`]:
                            regime.political_regime_name ===
                            "PRES REP HORS DEBAT"
                              ? "--"
                              : monthCumul.percent,
                        };
                        dataCopy[index] = jsonData;
                      }
                      return dataCopy;
                    }
                  );
                }
                if (key === "semester") {
                  Object.keys(politicalRegime.cumuls.semester).map((key) => {
                    let semester =
                      politicalRegime.cumuls.semester[parseInt(key)];
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
                    )[0];
                    let index = dataCopy.findIndex(
                      (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          regime.political_regime_name === "PRES REP HORS DEBAT"
                            ? "--"
                            : semester.display_hms,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] === `${semester.libelle_row} en %`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] === `${semester.libelle_row} en %`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          regime.political_regime_name === "PRES REP HORS DEBAT"
                            ? "--"
                            : semester.percent,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] ===
                        `${semester.libelle_row} en % (base 100)`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] ===
                        `${semester.libelle_row} en % (base 100)`
                    );

                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          regime.political_regime_name === "PRES REP HORS DEBAT"
                            ? "--"
                            : results &&
                              results.totals &&
                              results.totals.total_by_political_regime &&
                              results.totals.total_by_political_regime[
                                regime.political_regime_id
                              ]
                            ? results.totals.total_by_political_regime[
                                regime.political_regime_id
                              ].percent_base100
                            : "--",
                      };
                      dataCopy[index] = jsonData;
                    }
                    return dataCopy;
                  });
                }
                if (key === "year") {
                  Object.keys(politicalRegime.cumuls.year).map((key) => {
                    let year = politicalRegime.cumuls.year[parseInt(key)];
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
                    )[0];
                    let index = dataCopy.findIndex(
                      (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
                    );
                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          regime.political_regime_name === "PRES REP HORS DEBAT"
                            ? "--"
                            : year.display_hms,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === `${year.libelle_row} en %`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) => x["Libelle"] === `${year.libelle_row} en %`
                    );
                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          regime.political_regime_name === "PRES REP HORS DEBAT"
                            ? "--"
                            : year.percent,
                      };
                      dataCopy[index] = jsonData;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) =>
                        x["Libelle"] === `${year.libelle_row} en % (base 100)`
                    )[0];
                    index = dataCopy.findIndex(
                      (x: any) =>
                        x["Libelle"] === `${year.libelle_row} en % (base 100)`
                    );
                    if (jsonData !== undefined) {
                      jsonData = {
                        ...jsonData,
                        [`Cumuls ${politicalRegime.political_regime_name}`]:
                          regime.political_regime_name === "PRES REP HORS DEBAT"
                            ? "--"
                            : results &&
                              results.totals &&
                              results.totals.total_by_political_regime &&
                              results.totals.total_by_political_regime[
                                regime.political_regime_id
                              ]
                            ? results.totals.total_by_political_regime[
                                regime.political_regime_id
                              ].percent_base100
                            : "--",
                      };
                      dataCopy[index] = jsonData;
                    }
                    return dataCopy;
                  });
                }
                return dataCopy;
              });
            Object.keys(politicalRegimeSubGroup).length > 0 &&
              Object.keys(politicalRegimeSubGroup).map((key: string) => {
                let idGroup = parseInt(key);
                let politicalRegimeGroup: IPoliticalGroupSimple =
                  politicalRegimeSubGroup[idGroup];
                Object.keys(totals).map((key: string) => {
                  if (
                    key === "total_by_political_group" &&
                    state.filters?.date_type === "quarter"
                  ) {
                    let totalGroups = totals["total_by_political_group"];
                    Object.keys(totalGroups).length > 0 &&
                      Object.keys(totalGroups).map((key) => {
                        let idTotalGroup = parseInt(key);
                        let totalGroup: ITotalPoliticalGroup =
                          totalGroups[idTotalGroup];
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en hh:mm:ss"
                              : "Total du premier trimestre")
                        )[0];
                        let index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en hh:mm:ss"
                              : "Total du premier trimestre")
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en %"
                              : "Total du premier trimestre en %")
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en %"
                              : "Total du premier trimestre en %")
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en % (base 100)"
                              : "Total du premier trimestre en % (base 100)")
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en % (base 100)"
                              : "Total du premier trimestre en % (base 100)")
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent_base100,
                          };
                          dataCopy[index] = jsonData;
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du deuxième trimestre"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du deuxième trimestre"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du deuxième trimestre en %"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du deuxième trimestre en %"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du deuxième trimestre en % (base 100)"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du deuxième trimestre en % (base 100)"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent_base100,
                          };
                          dataCopy[index] = jsonData;
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du troisième trimestre"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du troisième trimestre"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du troisième trimestre en %"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du troisième trimestre en %"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du troisième trimestre en % (base 100)"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du troisième trimestre en % (base 100)"
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent_base100,
                          };
                          dataCopy[index] = jsonData;
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du quatrième trimestre"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du quatrième trimestre"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] === "Total du quatrième trimestre en %"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] === "Total du quatrième trimestre en %"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du quatrième trimestre en % (base 100)"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            "Total du quatrième trimestre en % (base 100)"
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent_base100,
                          };
                          dataCopy[index] = jsonData;
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) => x["Libelle"] === "Total du semestre"
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) => x["Libelle"] === "Total du semestre"
                        );
                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy = [...dataCopy, jsonData];
                        }
                        ///
                        jsonData = dataCopy.filter(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en %"
                              : "Total du premier trimestre en %")
                        )[0];
                        index = dataCopy.findIndex(
                          (x: any) =>
                            x["Libelle"] ===
                            (state.filters?.date_type === "quarter"
                              ? "Total du trimestre en %"
                              : "Total du premier trimestre en %")
                        );

                        if (
                          jsonData !== undefined &&
                          idTotalGroup ===
                            politicalRegimeGroup.political_group_id
                        ) {
                          jsonData = {
                            ...jsonData,
                            [politicalRegimeGroup.political_group_name]:
                              regime.political_regime_name ===
                              "PRES REP HORS DEBAT"
                                ? "--"
                                : totalGroup.percent,
                          };
                          dataCopy[index] = jsonData;
                        }
                        return dataCopy;
                      });
                  }
                  return dataCopy;
                });
                Object.keys(politicalRegimeGroup.cumuls).map(
                  (key: string, index: number) => {
                    if (key === "month") {
                      Object.keys(politicalRegimeGroup.cumuls.month).map(
                        (key: string, index: number) => {
                          let monthNum = parseInt(key);
                          let monthCumul =
                            politicalRegimeGroup.cumuls.month[monthNum];
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] === monthsOfYear[monthNum - 1]
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] === monthsOfYear[monthNum - 1]
                          );

                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                monthCumul.percent,
                            };
                            dataCopy[index] = jsonData;
                          }
                          return dataCopy;
                        }
                      );
                    }
                    if (key === "quarter") {
                      Object.keys(politicalRegimeGroup.cumuls.quarter).map(
                        (key) => {
                          let quarter: IPeriodSimple =
                            politicalRegimeGroup.cumuls.quarter[parseInt(key)];
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] ===
                              `${quarter.libelle_row} en hh:mm:ss`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] ===
                              `${quarter.libelle_row} en hh:mm:ss`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                quarter.display_hms,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] === `${quarter.libelle_row} en %`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] === `${quarter.libelle_row} en %`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : quarter.percent,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] ===
                              `${quarter.libelle_row} en % (base 100)`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] ===
                              `${quarter.libelle_row} en % (base 100)`
                          );

                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                            : results &&
                                    results.totals &&
                                    results.totals.total_by_political_group &&
                                    results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ]
                                  ? results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ].percent_base100
                                  : "--",
                            };
                            dataCopy[index] = jsonData;
                          }
                          return dataCopy;
                        }
                      );
                    }
                    if (key === "semester") {
                      Object.keys(politicalRegimeGroup.cumuls.semester).map(
                        (key) => {
                          let semester: IPeriodSimple =
                            politicalRegimeGroup.cumuls.semester[parseInt(key)];
                          jsonData = dataCopy.filter(
                            (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) => x["Libelle"] === `${semester.libelle_row} en hh:mm:ss`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                                [politicalRegimeGroup.political_group_name]:
                                semester.display_hms,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] === `${semester.libelle_row} en %`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] === `${semester.libelle_row} en %`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : semester.percent,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] ===
                              `${semester.libelle_row} en % (base 100)`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] ===
                              `${semester.libelle_row} en % (base 100)`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : results &&
                                    results.totals &&
                                    results.totals.total_by_political_group &&
                                    results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ]
                                  ? results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ].percent_base100
                                  : "--",
                            };
                            dataCopy[index] = jsonData;
                          }
                          return dataCopy;
                        }
                      );
                    }
                    if (key === "year") {
                      Object.keys(politicalRegimeGroup.cumuls.year).map(
                        (key) => {
                          let year: IPeriodSimple =
                            politicalRegimeGroup.cumuls.year[parseInt(key)];
                          jsonData = dataCopy.filter(
                            (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) => x["Libelle"] === `${year.libelle_row} en hh:mm:ss`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                                [politicalRegimeGroup.political_group_name]:
                                year.display_hms,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] === `${year.libelle_row} en %`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] === `${year.libelle_row} en %`
                          );
                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : year.percent,
                            };
                            dataCopy[index] = jsonData;
                          }
                          jsonData = dataCopy.filter(
                            (x: any) =>
                              x["Libelle"] ===
                              `${year.libelle_row} en % (base 100)`
                          )[0];
                          index = dataCopy.findIndex(
                            (x: any) =>
                              x["Libelle"] ===
                              `${year.libelle_row} en % (base 100)`
                          );

                          if (jsonData !== undefined) {
                            jsonData = {
                              ...jsonData,
                              [politicalRegimeGroup.political_group_name]:
                                regime.political_regime_name ===
                                "PRES REP HORS DEBAT"
                                  ? "--"
                                  : results &&
                                    results.totals &&
                                    results.totals.total_by_political_group &&
                                    results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ]
                                  ? results.totals.total_by_political_group[
                                      politicalRegimeGroup.political_group_id
                                    ].percent_base100
                                  : "--",
                            };
                            dataCopy[index] = jsonData;
                          }
                          return dataCopy;
                        }
                      );
                    }
                    return dataCopy;
                  }
                );

                dataCopy.map((x: any) => {
                  if (
                    x[politicalRegimeGroup.political_group_name] === undefined
                  ) {
                    x[politicalRegimeGroup.political_group_name] = "--";
                  }
                  return x;
                });
                return dataCopy;
              });
            return dataCopy;
          });
      }
      return {
        ...state,
        dataPercent: dataCopy,
        data: dataCopy,
      };
    }
    case IDashboardActionTypes.BUILD_COLUMNS: {
      let results = state.dashboardResults;
      let columns: IGroupList[] = [];
      if (results !== null) {
        let politicalRegimeList: IPoliticalRegime[] =
          results.political_regime_ids as IPoliticalRegime[];
        let libelle: string = results.search_libelle;

        columns.push({
          Header: "", //"Add media logos here",
          id: "Libelle",
          columns: [
            {
              Header: libelle,
              accessor: "Libelle",
              Footer: "Libelle",
            },
          ],
        });
        politicalRegimeList !== undefined &&
          politicalRegimeList.length > 0 &&
          politicalRegimeList.map((regime: IPoliticalRegime) => {
            let politicalRegime: IPoliticalRegime = regime;
            let politicalRegimeSubGroup: IPoliticalGroupId =
              politicalRegime.political_group_ids;

            let subColumns: ISubGroupList[] = [];
            columns.push({
              Header: politicalRegime.political_regime_name,
              Footer: politicalRegime.political_regime_name,
              id: politicalRegime.political_regime_id,
              accessor: politicalRegime.political_regime_name,
              cid: politicalRegime.political_regime_id,
              columns: subColumns,
            });
            if (Object.keys(politicalRegimeSubGroup).length > 0) {
              Object.keys(politicalRegimeSubGroup).map((key: string) => {
                let idGroup = parseInt(key);
                let politicalRegimeGroup: IPoliticalGroupSimple =
                  politicalRegimeSubGroup[idGroup];

                if (
                  Object.keys(politicalRegimeSubGroup).length > 1 ||
                  (Object.keys(politicalRegimeSubGroup).length === 1 &&
                    politicalRegimeGroup.political_group_name !==
                      politicalRegime.political_regime_name)
                ) {
                  subColumns.push({
                    Header: politicalRegimeGroup.political_group_name,
                    Footer: politicalRegimeGroup.political_group_name,
                    accessor: politicalRegimeGroup.political_group_name,
                    id: politicalRegimeGroup.political_group_id,
                    cid: politicalRegimeGroup.political_group_id,
                    show:
                      Object.keys(politicalRegimeSubGroup).length > 1 ||
                      (Object.keys(politicalRegimeSubGroup).length === 1 &&
                        politicalRegimeGroup.political_group_name !==
                          politicalRegime.political_regime_name)
                        ? false
                        : true,
                  });
                }
                return subColumns;
              });
            }
            if (Object.keys(politicalRegimeSubGroup).length > 0) {
              subColumns.push({
                Header: `Cumuls ${politicalRegime.political_regime_name}`,
                Footer: `Cumuls ${politicalRegime.political_regime_name}`,
                accessor: `Cumuls ${politicalRegime.political_regime_name}`,
                id: `Cumuls ${politicalRegime.political_regime_name}`,
                cid: politicalRegime.id,
                show: true,
              });
            }
            return columns;
          });
        columns.push({
          Header: "",
          id: "Total",
          columns: [
            {
              Header: "Total",
              accessor: "Total",
              Footer: "Total",
            },
          ],
        });
      }
      return {
        ...state,
        columns: columns,
      };
    }
    case IDashboardActionTypes.BUILD_DATA_MONTH_HMS: {
      let dataCopy = [...state.data];
      let jsonData: any = {};

      if (state.dashboardResults !== null) {
        let results = state.dashboardResults;
        if (results.political_regime_ids !== undefined) {
          results.list_days !== undefined &&
            Object.keys(results.list_days).map((key) => {
              let days = results.list_days;
              let jsonData = {
                Libelle: days[key],
              };
              dataCopy.push(jsonData);
              return dataCopy;
            });

          dataCopy.push({
            Libelle: "Total en hh:mm:ss",
          });
          dataCopy.push({
            Libelle: "Total en %",
          });
          dataCopy.push({
            Libelle: "Total en % (base 100)",
          });

          /// remplir le regime (colonne cumul)
          results.political_regime_ids.map((regime) => {
            let politicalRegime = regime;
            let regimeName = politicalRegime.political_regime_name;
            let politicalRegimeSubGroup: IPoliticalGroupId =
              politicalRegime.political_group_ids;

            Object.keys(results.totals.total_by_political_regime).map((key) => {
              let idTotalRegime = parseInt(key);
              let totalRegime =
                results.totals.total_by_political_regime[idTotalRegime];
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === "Total en hh:mm:ss"
              )[0];
              if (
                jsonData !== undefined &&
                idTotalRegime === politicalRegime.political_regime_id
              ) {
                jsonData[`Cumuls ${politicalRegime.political_regime_name}`] =
                  totalRegime.display_hms;
              }
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === "Total en %"
              )[0];
              if (
                jsonData !== undefined &&
                idTotalRegime === politicalRegime.political_regime_id
              ) {
                jsonData[`Cumuls ${politicalRegime.political_regime_name}`] =
                  totalRegime.percent;
              }
              jsonData = dataCopy.filter(
                (x: any) => x["Libelle"] === "Total en % (base 100)"
              )[0];
              if (
                jsonData !== undefined &&
                idTotalRegime === politicalRegime.political_regime_id
              ) {
                jsonData[`Cumuls ${politicalRegime.political_regime_name}`] =
                  totalRegime.percent_base100;
              }
              return jsonData;
            });

            Object.keys(politicalRegimeSubGroup).length > 0 &&
              Object.keys(politicalRegimeSubGroup).map((key: string) => {
                let idGroup = parseInt(key);
                let politicalRegimeGroup: IPoliticalGroupSimple =
                  politicalRegimeSubGroup[idGroup];
                //prepare groups data
                Object.keys(politicalRegimeGroup.cumuls).length > 0 &&
                  Object.keys(politicalRegimeGroup.cumuls).map((key) => {
                    Object.keys(politicalRegimeGroup.cumuls.days).length > 0 &&
                      Object.keys(politicalRegimeGroup.cumuls.days).map(
                        (key) => {
                          let day = politicalRegimeGroup.cumuls.days[key];
                          jsonData = dataCopy.filter(
                            (x) => x["Libelle"] === day.libelle_row
                          )[0];
                          if (jsonData !== undefined) {
                            jsonData[
                              politicalRegimeGroup.political_group_name
                            ] = day.display_hms;
                          }
                          return jsonData;
                        }
                      );
                    return jsonData;
                  });
                dataCopy.map((x) => {
                  if (
                    x[politicalRegimeGroup.political_group_name] === undefined
                  ) {
                    x[politicalRegimeGroup.political_group_name] = "--";
                  }
                  return x;
                });
                // prepare total rows data
                Object.keys(results.totals.total_by_political_group).map(
                  (key) => {
                    let idTotalGroup = parseInt(key);
                    let totalGroup =
                      results.totals.total_by_political_group[idTotalGroup];
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === "Total en hh:mm:ss"
                    )[0];
                    if (
                      jsonData !== undefined &&
                      idTotalGroup === politicalRegimeGroup.political_group_id
                    ) {
                      jsonData[politicalRegimeGroup.political_group_name] =
                        totalGroup.display_hms;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === "Total en %"
                    )[0];
                    if (
                      jsonData !== undefined &&
                      idTotalGroup === politicalRegimeGroup.political_group_id
                    ) {
                      jsonData[politicalRegimeGroup.political_group_name] =
                        totalGroup.percent;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === "Total en % (base 100)"
                    )[0];
                    if (
                      jsonData !== undefined &&
                      idTotalGroup === politicalRegimeGroup.political_group_id
                    ) {
                      jsonData[politicalRegimeGroup.political_group_name] =
                        totalGroup.percent_base100;
                    }
                    return jsonData;
                  }
                );

                return jsonData;
              });

            //prepare Cumuls data
            Object.keys(politicalRegime.cumuls).map((key) => {
              let cumul_by_regime = politicalRegime.cumuls;

              Object.keys(cumul_by_regime.days).map((key) => {
                let day = cumul_by_regime.days[key];
                jsonData = dataCopy.filter(
                  (x: any) => x["Libelle"] === day.libelle_row
                )[0];
                if (jsonData !== undefined) {
                  jsonData[`Cumuls ${regimeName}`] = day.display_hms;
                }
                return jsonData;
              });
              return jsonData;
            });
            dataCopy.map((x) => {
              if (x[`Cumuls ${regimeName}`] === undefined) {
                x[`Cumuls ${regimeName}`] = "--";
              }
              return x;
            });
            return jsonData;
          });

          /// remplir total data
          Object.keys(results.totals.total_by_day).map((key) => {
            let day: IPeriodSimple = results.totals.total_by_day[key];
            jsonData = dataCopy.filter(
              (x) => x["Libelle"] === day.libelle_row
            )[0];
            if (jsonData !== undefined) {
              jsonData["Total"] = day.display_hms;
            }
            return jsonData;
          });
          jsonData = dataCopy.filter((x) => x["Libelle"] === "Total en hh:mm:ss")[0];
          if (jsonData) {
            jsonData["Total"] = results.totals.total_duration_no_pres.display_hms;
          }
          jsonData = dataCopy.filter((x) => x["Libelle"] === "Total en %")[0];
          if (jsonData) {
            jsonData["Total"] = "100%";
          }
          jsonData = dataCopy.filter(
            (x) => x["Libelle"] === "Total en % (base 100)"
          )[0];
          if (jsonData) {
            jsonData["Total"] = "100%";
          }

          dataCopy.map((row) => {
            if (row["Total"] === undefined) {
              row["Total"] = "--";
            }
            return row;
          });
        }
      }
      return {
        ...state,
        dataHms: dataCopy,
        data: dataCopy,
      };
    }
    case IDashboardActionTypes.BUILD_DATA_MONTH_PERCENT: {
      let dataCopy = [...state.dataPercent];
      let jsonData: any = {};

      if (state.dashboardResults !== null) {
        let results = state.dashboardResults;
        results.list_days !== undefined &&
          Object.keys(results.list_days).map((key) => {
            let days = results.list_days;
            let jsonData = {
              Libelle: days[key],
            };
            dataCopy.push(jsonData);
            return dataCopy;
          });

        dataCopy.push({
          Libelle: "Total en hh:mm:ss",
        });
        dataCopy.push({
          Libelle: "Total en %",
        });
        dataCopy.push({
          Libelle: "Total en % (base 100)",
        });

        /// remplir le regime (colonne cumul)
        results.political_regime_ids !== undefined &&
          results.political_regime_ids !== null &&
          results.political_regime_ids.map((regime) => {
            let politicalRegime = regime;
            let regimeName = politicalRegime.political_regime_name;
            let politicalRegimeSubGroup: IPoliticalGroupId =
              politicalRegime.political_group_ids;

            results.totals.total_by_political_regime !== undefined &&
              Object.keys(results.totals.total_by_political_regime).map(
                (key) => {
                  let idTotalRegime = parseInt(key);
                  let totalRegime =
                    results.totals.total_by_political_regime[idTotalRegime];
                  jsonData = dataCopy.filter(
                    (x: any) => x["Libelle"] === "Total en hh:mm:ss"
                  )[0];
                  if (
                    jsonData !== undefined &&
                    idTotalRegime === politicalRegime.political_regime_id
                  ) {
                    jsonData[
                      `Cumuls ${politicalRegime.political_regime_name}`
                    ] =
                      regime.political_regime_name === "PRES REP HORS DEBAT"
                        ? "--"
                        : totalRegime.display_hms;
                  }
                  jsonData = dataCopy.filter(
                    (x: any) => x["Libelle"] === "Total en %"
                  )[0];
                  if (
                    jsonData !== undefined &&
                    idTotalRegime === politicalRegime.political_regime_id
                  ) {
                    jsonData[
                      `Cumuls ${politicalRegime.political_regime_name}`
                    ] =
                      regime.political_regime_name === "PRES REP HORS DEBAT"
                        ? "--"
                        : totalRegime.percent;
                  }
                  jsonData = dataCopy.filter(
                    (x: any) => x["Libelle"] === "Total en % (base 100)"
                  )[0];
                  if (
                    jsonData !== undefined &&
                    idTotalRegime === politicalRegime.political_regime_id
                  ) {
                    jsonData[
                      `Cumuls ${politicalRegime.political_regime_name}`
                    ] =
                      regime.political_regime_name === "PRES REP HORS DEBAT"
                        ? "--"
                        : totalRegime.percent_base100;
                  }
                  return jsonData;
                }
              );

            politicalRegimeSubGroup !== undefined &&
              Object.keys(politicalRegimeSubGroup).length > 0 &&
              Object.keys(politicalRegimeSubGroup).map((key: string) => {
                let idGroup = parseInt(key);
                let politicalRegimeGroup: IPoliticalGroupSimple =
                  politicalRegimeSubGroup[idGroup];
                //prepare groups data
                politicalRegimeGroup.cumuls !== undefined &&
                  Object.keys(politicalRegimeGroup.cumuls).length > 0 &&
                  Object.keys(politicalRegimeGroup.cumuls).map((key) => {
                    politicalRegimeGroup.cumuls.days !== undefined &&
                      Object.keys(politicalRegimeGroup.cumuls.days).length >
                        0 &&
                      Object.keys(politicalRegimeGroup.cumuls.days).map(
                        (key) => {
                          let day = politicalRegimeGroup.cumuls.days[key];
                          jsonData = dataCopy.filter(
                            (x) => x["Libelle"] === day.libelle_row
                          )[0];
                          if (jsonData !== undefined) {
                            jsonData[
                              politicalRegimeGroup.political_group_name
                            ] = day.percent;
                          }
                          return jsonData;
                        }
                      );
                    return jsonData;
                  });
                dataCopy.map((x) => {
                  if (
                    x[politicalRegimeGroup.political_group_name] === undefined
                  ) {
                    x[politicalRegimeGroup.political_group_name] = "--";
                  }
                  return x;
                });
                // prepare total rows data
                Object.keys(results.totals.total_by_political_group).map(
                  (key) => {
                    let idTotalGroup = parseInt(key);
                    let totalGroup =
                      results.totals.total_by_political_group[idTotalGroup];
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === "Total en hh:mm:ss"
                    )[0];
                    if (
                      jsonData !== undefined &&
                      idTotalGroup === politicalRegimeGroup.political_group_id
                    ) {
                      jsonData[politicalRegimeGroup.political_group_name] =
                        regime.political_regime_name === "PRES REP HORS DEBAT"
                          ? "--"
                          : totalGroup.display_hms;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === "Total en %"
                    )[0];
                    if (
                      jsonData !== undefined &&
                      idTotalGroup === politicalRegimeGroup.political_group_id
                    ) {
                      jsonData[politicalRegimeGroup.political_group_name] =
                        regime.political_regime_name === "PRES REP HORS DEBAT"
                          ? "--"
                          : totalGroup.percent;
                    }
                    jsonData = dataCopy.filter(
                      (x: any) => x["Libelle"] === "Total en % (base 100)"
                    )[0];
                    if (
                      jsonData !== undefined &&
                      idTotalGroup === politicalRegimeGroup.political_group_id
                    ) {
                      jsonData[politicalRegimeGroup.political_group_name] =
                        regime.political_regime_name === "PRES REP HORS DEBAT"
                          ? "--"
                          : totalGroup.percent_base100;
                    }
                    return jsonData;
                  }
                );

                return jsonData;
              });

            //prepare Cumuls data
            Object.keys(politicalRegime.cumuls).map((key) => {
              let cumul_by_regime = politicalRegime.cumuls;

              Object.keys(cumul_by_regime.days).map((key) => {
                let day = cumul_by_regime.days[key];
                jsonData = dataCopy.filter(
                  (x: any) => x["Libelle"] === day.libelle_row
                )[0];
                if (jsonData !== undefined) {
                  jsonData[`Cumuls ${regimeName}`] = day.percent;
                }
                return jsonData;
              });
              return jsonData;
            });
            dataCopy.map((x) => {
              if (x[`Cumuls ${regimeName}`] === undefined) {
                x[`Cumuls ${regimeName}`] = "--";
              }
              return x;
            });
            return jsonData;
          });

        /// remplir total data
        Object.keys(results.totals.total_by_day).map((key) => {
          let day: IPeriodSimple = results.totals.total_by_day[key];
          jsonData = dataCopy.filter(
            (x) => x["Libelle"] === day.libelle_row
          )[0];
          if (jsonData !== undefined) {
            jsonData["Total"] = day.display_hms;
          }
          return jsonData;
        });
        jsonData = dataCopy.filter((x) => x["Libelle"] === "Total en hh:mm:ss")[0];
        jsonData["Total"] = results.totals.total_duration_no_pres.display_hms;
        jsonData = dataCopy.filter((x) => x["Libelle"] === "Total en %")[0];
        jsonData["Total"] = "100%";
        jsonData = dataCopy.filter(
          (x) => x["Libelle"] === "Total en % (base 100)"
        )[0];
        jsonData["Total"] = "100%";

        dataCopy.map((row) => {
          if (row["Total"] === undefined) {
            row["Total"] = "--";
          }
          return row;
        });
      }
      return {
        ...state,
        dataPercent: dataCopy,
        data: dataCopy,
      };
    }
    case IDashboardActionTypes.SET_DISPLAY_FORMAT: {
      let filtersCopy = { ...state.filters };
      filtersCopy.display_format = action.payload;
      return {
        ...state,
        filters: filtersCopy,
      };
    }
    case IDashboardActionTypes.GET_DASHBOARD_DETAIL: {
      return {
        ...state,
        detailsFilters: action.payload,
        isLoadingDetail: true,
      };
    }
    case IDashboardActionTypes.GET_DASHBOARD_DETAIL_SUCCESS: {
      return {
        ...state,
        dashboardDetail: action.payload,
        isLoadingDetail: false,
      };
    }
    case IDashboardActionTypes.RESET_DATA: {
      return initialState;
    }
    case IDashboardActionTypes.INITIALIZE_DATA: {
      return {
        ...state,
        dataHms: [],
        filters: {
          media_ids: [],
          program_type_ids: [],
          media_str: [],
          program_type_str: [],
          program_editors_ids: [],
          program_editors_str: [],
          time_slot_start: "",
          time_slot_end: "",
          date_type: "calendar",
          date_start: new Date(),
          date_end: new Date(),
          display_format: "duration",
        },
      };
    }
    case IDashboardActionTypes.GET_EMISSION_AUTOCOMPLETE: {
      return {
        ...state,
        isEmissionAutocompleteLoading: true,
        emissions: [],
      };
    }
    case IDashboardActionTypes.GET_EMISSION_AUTOCOMPLETE_SUCCESS: {
      return {
        ...state,
        emissions: action.payload,
        isEmissionAutocompleteLoading: false,
      };
    }
    case IDashboardActionTypes.CLEAR_EMISSION_LIST: {
      return {
        ...state,
        isEmissionAutocompleteLoading: false,
        emissions: [],
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as DashboardReducer };
